import { useCallback, useEffect, useRef, useState } from "react";
import ListingsList from "./ListingsList";
import SearchMap from "./SearchMap";
import MobileStickyBar from "../components/Mobile/MobileStickyBar";

function Mobile() {
  const [showMap, setShowMap] = useState(false);
  const [wrapHeight, setWrapHeight] = useState(0);
  const [stickyVisible, setStickyVisible] = useState(true);

  const appWrap = useRef(null);
  const topSentinelRef = useRef(null);

  const handleShowMap = useCallback(() => {
    setShowMap(!showMap);
    window.scrollTo(0, 0, {
      behavior: "smooth",
    });
  }, [showMap]);

  useEffect(() => {
    const bottomSentinel = document.querySelector("footer");
    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log(entry.isIntersecting);
        setTimeout(() => {
          setStickyVisible(!entry.isIntersecting);
        }, 100);
      },
      { threshold: 0 },
    );

    if (bottomSentinel) observer.observe(bottomSentinel);

    return () => {
      if (bottomSentinel) observer.unobserve(bottomSentinel);
    };
  }, [showMap, stickyVisible]);
  return (
    <>
      <div ref={topSentinelRef}></div>
      <div className="app-annunci uk-position-relative" ref={appWrap}>
        <div className="render-app-wrapper uk-child-width-1-1 uk-grid-collapse">
          {showMap && (
            <div className="search-map-wrap" ref={appWrap}>
              <SearchMap />
            </div>
          )}
          {!showMap && (
            <div className="listing-list-wrap" ref={appWrap}>
              <ListingsList />
            </div>
          )}
        </div>
        {stickyVisible && (
          <MobileStickyBar
            onHandleShowMap={handleShowMap}
            showMap={showMap}
            wrapHeight={wrapHeight}
          />
        )}
      </div>
    </>
  );
}

export default Mobile;
